// extracted by mini-css-extract-plugin
module.exports = {"moneyDollarContainer":"style-module__moneyDollarContainer___171fX","moneyDollar":"style-module__moneyDollar___3CK3H"};